import { useEffect, useState } from 'react';
import { VisionCanvas } from '@/components/common/vision-canvas.tsx';
import { CollaborationInitializer } from '@/initializers/collaboration-initializer';
import type { BaseAsset } from '@akavirtual/deai-web-core';
import { ChatProvider } from '@/context/chat-provider';
import { DEAIChatBox } from '@/components/chat/deai-chatbox';
import { StartOverlay } from '@/components/chat/deai-startoverlay';
import { assetService } from '@/services/asset-service';

type ScenePreviewProps = {
  assetId: string;
};

export const ScenePreview = ({ assetId }: ScenePreviewProps) => {
  const [definition, setDefinition] = useState<BaseAsset | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!assetId) return;

    const fetchScene = async () => {
      setIsLoading(true);
      setError(null);
      try {
        const content = await assetService.getAssetContent(assetId);
        setDefinition({ data:content } as BaseAsset);
      } catch (err) {
        setError((err as Error).message);
      } finally {
        setIsLoading(false);
      }
    };
    fetchScene();
  }, [assetId]);

  if (isLoading) return <div className="flex h-full w-full items-center justify-center">Loading Preview...</div>;
  if (error) return <div className="flex h-full w-full items-center justify-center text-destructive">{error}</div>;
  if (!definition) return null;

  return (
    <VisionCanvas
      key={definition.uuid}
      instanceId={`agent-scene-${definition.uuid}`}
      className='h-full w-full'
      definition={definition}
      initializer={CollaborationInitializer}
      assetBaseUrl={window.location.origin}
    >
      <ChatProvider>
        <DEAIChatBox className="absolute h-full w-3/4 max-w-lg mt-4 right-5 flex flex-col text-white rounded-lg" />
        <StartOverlay soundURL='audio/click.wav' />
      </ChatProvider>
    </VisionCanvas>
  );
};